import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { Dcl } from './components/Dcl';
import { Sot } from './components/sot/Sot';
//import { IsoNova } from './components/IsoNova';
import { IsoNova } from './components/IsoNovaTankwash/IsoNovaTankwash';
import { DriverStatusUpdate } from './components/DriverStatusUpdate';

import './custom.css'
import './stylesheets/index.css';

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <Layout>
        <Route exact path='/' component={Home} />
            <Route path='/dcl' component={Dcl} />
            <Route path='/sot' component={Sot} />
            <Route path='/isonova' component={IsoNova} />
            <Route path='/driverstatus' component={DriverStatusUpdate} />
      </Layout>
    );
  }
}
